export default __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLEj6Z11lFc-K.a5fe02a1.woff2";